import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=21e2d74c&scoped=true&"
import script from "./Selector.vue?vue&type=script&lang=js&"
export * from "./Selector.vue?vue&type=script&lang=js&"
import style0 from "./Selector.vue?vue&type=style&index=0&id=21e2d74c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2d74c",
  null
  
)

export default component.exports